import { render, staticRenderFns } from "./CreateShipment.vue?vue&type=template&id=4ce85fcc"
import script from "./CreateShipment.vue?vue&type=script&lang=js"
export * from "./CreateShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports